import React, { useState, useEffect, useRef } from "react";
import { Col, Container, Modal, Row, Button, Form } from 'react-bootstrap';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css'
import moment from "moment/moment";
import { useDispatch, useSelector } from "react-redux";
import APICom from "../../utils/helpers/APICom";
import TimePicker from "rc-time-picker";
import ConfirmationModal from '../Controls/ConfirmationModal';
import GridControl from "../Controls/gridControl";
import { format } from 'date-fns';



function MTDiagnostic(props){

    const TITLE = "Microtransit Diagnostic Logs";
    const CANCEL_BUTTON = "Close";

    const { GlobalASCSData, AffiliateData } = useSelector((store) => store.combinedata);

    const [MTDiagnosticData, setMTDiagnosticData] = useState([]);
    const [showLoader, setShowLoader] = useState(false);
    const [fromDate, setFromDate] = useState("");
    const [toDate, setToDate] = useState("");
    const [failedBooking, setFailedBooking] = useState(false);
    const [bookingType, setBookingType] = useState(-1);

    const transitTypeRef = useRef([]);



    useEffect(()=> {

        // setMTDiagnosticData([])
        // initializeMTDiagnosticGrid()

        setMTDiagnosticData([{
            "iID": null,"Record Receieved": "","PU Date": "","vPUStopName": "","vDOStopName": "","PUAddress": "","DOAddress": "","PUReqAddressType": "","DOReqAddressType": "",
            "ComputedPUStop": "","ComputedDOStop": "","RCZList": "","PUStopDist": null,"DOStopDist": null,"iAppID": "","vStopsOutput": "","iMode": null,"RCZIDsList": "",
            "RouteIDsList": "","iAffiliateID": null,"VPULatitude": "","vPULongitude": "","vDOLatitude": "","vDOLongitude": "","DEstimatedTime": null,"bCheckServiceHours": null,
            "bCheckServiceHoursWthSoftWarning": null,"bSkipTableOutput": null,"ErrorMessage": "","rcz_name": "","RCZIDsListAsOut": "","ZonesIDStr": "","vPUStopRCZ": "",
            "vDOStopRCZ": "","iUserID": null,"vCustomerPhone": "","vCustomerName": "","vCustomerAppType": "","vCustomerDeviceModel": "","vCustomerMarsID": ""}])

        }, []);


    useEffect(() => {
        try{
          let sections = props.selectedAffiliates.split(',');
          let firstAff = "";
          if(sections.length > 0)
          {
            firstAff = parseInt(sections[0]);
          }
          else
          {
            firstAff = (props.selectedAffiliates && props.selectedAffiliates !== ""?parseInt(props.selectedAffiliates):0);
          }
          if(firstAff > 0)
          {
            transitTypeRef.current = AffiliateData.filter((item,index) => {
              try{
                return parseInt(item.AffiliateID) === firstAff;
              }
              catch(err){console.log(err);}
            });
          }
          
        }
        catch(err){console.log(err);}
      }, 
      
      [props.selectedAffiliates]);



    const handleGetMTDiagnosticData = async() => {
        try {

            const formattedFromDate = fromDate ? format(fromDate, 'yyyy-MM-dd') : "";
            const formattedToDate = toDate ? format(toDate, 'yyyy-MM-dd') : "";

            let params = {
                "iAffiliateID": transitTypeRef.current[0].AffiliateID,
                "dtFromDate": formattedFromDate,
                "dtToDate": formattedToDate,
                "bFailedBookings": failedBooking,
                "bookingType": parseInt(bookingType)
            }

            let response = await APICom.fetchData("", "MTDiagnostic/MTDiagnosticLogs", "post", { "Content-Type": "application/json" }, params, null);
            let result = response.data;
            if(Number(result.length) > 0)
            {
                setMTDiagnosticData(result)

            }
            else
            {
                setMTDiagnosticData([])
               
            }
        } catch (error) {
            
        }
    }

    const handleCloseMTDiagnosticDialog = () => {
        if (props.showMTDiagnosticDialog) {
            props.setMTDiagnosticDialog(false);
        }
    }

    const [MTDiagnosticGridOptions, setMTDiagnosticGridOptions] = useState({
        height: 300,
        heightoffset: 600,
        calculateHeight: false,
        pagination: true,
        paginationMode: "local",
        paginationSize: 5,
        paginationSizeSelector: [5, 10, 15, 20, 25],
        selectable: true,
        reactiveData:true, //enable data reactivity
        layout: "fitDataStretch",
        placeholder:"No Data Available",
        clipboard: true,
        selectableRangeMode: "click",
        GridName:"MTDiagnosticGrid",
        paginationCounter:"rows",
        intervalTimer: GlobalASCSData.find(dict => dict.SubTitle === "Tb01") === undefined? 60000:GlobalASCSData.find(dict => dict.SubTitle === "Tb01").value*2000,
        movableColumns:true,
        vDefaultGridName: "MTDiagnosticGrid",
        index: "iID",
        autoColumns: true,
        sortCondition: true,
        bSysUser: 1,
        intervalEnable: false,
        persistence: false,
        bWebApplySettingToAll: true,
        GridReturnOnlyIDColumnInRowData: false,
        AlwaysHiddenColumns:["iID", "vCustomerMarsID", "iUserID"],
        footerElement: '',
        ActionList: false,
        tableDoubleClickFunc: function(table, row) {
        },
        footerElementHandles: function (table) {},
        rowSelectionChangeHandle: function(data){

        },
    });

    const handleMTDiagnosticGrid = () => {
        console.log("Reload MTDiagnostic Grid");
    };


    return (
        <>
            {props.showMTDiagnosticDialog? 
                <Modal show={props.showMTDiagnosticDialog ? 1 : 0} centered onHide={handleCloseMTDiagnosticDialog} backdrop="static" keyboard={true}  size="lg" animation={true}
                    aria-labelledby="contained-modal-title-vcenter" dialogClassName="modal-tripDetails-width">
                    <Modal.Header className='activate_dialog_header_bgcolor tripDetails-DialogHeader user-select-none' closeButton>
                        <Modal.Title>{TITLE}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>

                        <Form>
                            <Row>
                                <Col md={3}>
                                    <Form.Label className="user-select-none">From Date</Form.Label>
                                </Col>
                                <Col md={3}>
                                    <Form.Label className="user-select-none">To Date</Form.Label>
                                </Col>
                                <Col md={2}>
                                    <Form.Label className="user-select-none">Booking Type</Form.Label>
                                </Col>
                            </Row>
                            <Row>
                                <Col md={3}>
                                    <Form.Group controlId="formFromDate">
                                        <DatePicker selected={fromDate} onChange={date => setFromDate(date)} className="form-control" placeholderText="Select Date"/>
                                    </Form.Group>
                                </Col>
                                <Col md={3}>
                                    <Form.Group controlId="formToDate">
                                        <DatePicker selected={toDate} onChange={date => setToDate(date)} className="form-control" placeholderText="Select Date"/>
                                    </Form.Group>
                                </Col>
                                <Col md={2}>
                                    <Form.Group controlId="formBookingType">
                                        <Form.Control as="select" value={bookingType} onChange={e => setBookingType(e.target.value)} aria-label="Select Booking Type">
                                            <option value="-1">All</option>
                                            <option value="10">Booking App</option>
                                            <option value="26">Call Center</option>
                                        </Form.Control>
                                    </Form.Group>
                                </Col>
                                <Col md={2}>
                                    <Form.Group controlId="formFailedBooking">
                                        <Form.Check type="checkbox" className="small user-select-none" label="Failed Booking" checked={failedBooking} 
                                            onChange={e => setFailedBooking(e.target.checked)}
                                        />
                                    </Form.Group>
                                </Col>
                                
                                <Col md={2}>
                                    <Button variant="primary" onClick={handleGetMTDiagnosticData}>
                                        Search
                                    </Button>
                                </Col>
                            </Row>
                        </Form>

                        <Row className="mt-5">
                            {MTDiagnosticData && MTDiagnosticData.length > 0 && (
                                <GridControl ShowLoader={showLoader} ReloadDataFunction={handleMTDiagnosticGrid} Data={MTDiagnosticData}
                                options={MTDiagnosticGridOptions}/>
                            )}
                        </Row>

                       
                    </Modal.Body>
                    <Modal.Footer style={{backgroundColor:"#4c859b"}} className="p-1">
                        <Button className="tripDetails_edit_btn_color" variant="secondary" onClick={handleCloseMTDiagnosticDialog}>
                            {CANCEL_BUTTON}
                        </Button>
                        
                    </Modal.Footer>
                </Modal>
            :""}
        </>
    )
}

export default MTDiagnostic;